import { homeConstants } from "../constants/home.constants";
import { entityConstants } from "../constants/entity.constants";
import { getFirebase } from "react-redux-firebase";
import humanize from "underscore.string";
import { alertActions } from "./alert.actions";
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates';
import { LookAheadStatuses } from "../containers/helpers/AllTasksScreen";
import { homeActions } from './home.actions';
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { getProjectId } from "../selectors/project.selector";
import { getOffDays, getPhaseTags, getSelectedPhasePlanId, getTrades } from "../selectors/phaseplan.selector";
import { PhaseTag } from "../models/PhaseTag";
import { ColumnType } from "../components/PhasePlan/Column";
import { getLookaheadMilestoneTags, getLookaheadOffDays, getLookaheadTags, getMilestoneKeys, getRowGroupMaxEnds, getRowGroups, getSelectedLookaheadId } from "../selectors/lookahead.selector";
import { Trade } from "../models/Trade";
import { getDbFromTagType } from "./phaseplan.actions";
import { SelectedTag } from "../models/ TagType";
import { ImportTag, TagToBeUploaded, NEW_TRADE } from "../components/Dialogs/UploadTasksDialog";
import moment, { Moment } from 'moment'
import { ConfirmationNumberTwoTone } from "@material-ui/icons";
import { LookaheadTag, LookaheadTagStatus } from "../models/LookaheadTag";
import { RowGroup } from "../models/Lookahead";
import { projectActions } from "./project.actions";
import bugsnagClient from '../utils/BugSnagClient';

const _ = require('lodash')

export const entityActions = {
    saveFormData,
    saveProfile,
    createProject,
    saveUploadTasksTask,
    uploadTasks,
    addInviteUser,
    handleFilterDateChange,
    requestUpdate,
    sendUpdateRequest,
    saveUpdateRequestProgress,
    uploadedSchedule,
    removeTaskByRoute,
    closeUpdateRequestDialog,
    addInviteUsers,
    addInviteUserWithPlan,
    createLookAhead,
    endLookAhead,
    closeProjectDialog,
    createId,
    deleteTag,
    duplicateTag,
    duplicateTrade,
    ripTag,
    deleteTrade
};

export const ProjectLookAheadStatus = {
    OPEN: 'open',
    CLOSED: 'closed'
}

export const isValidUploadDate = (stringDate: string): boolean => {

  const t4 = moment(stringDate, ['DD-MMM-YY', 'D-MMM-YY','MM-DD-YYYY', 'l'], true)


  const t4Valid = t4.isValid()

  if(t4Valid){
    return true
  }


  return false
}

const convertDate = (stringDate: string): Moment | null => {

  const t4 = moment(stringDate, [ 'DD-MMM-YY', 'D-MMM-YY', 'MM-DD-YYYY', 'l'], true)
  const t4Valid = t4.isValid()

  if(t4Valid){

    return t4
  }


  return null
}

export const isDateOrderCorrect = (startDateStr: string, endDateStr:string) => {
  const startDate = convertDate(startDateStr)
  const endDate = convertDate(endDateStr)

  if(!startDate || !endDate){
    return false
  }

  if(endDate.isSameOrAfter(startDate)) {
    return true
  }

  return false
}

function isObject(obj) {
    return obj === Object(obj);
}

function handleFilterDateChange(newDate) {
    return (dispatch, getState) => {
        dispatch({
          type: entityConstants.WEEK_FILTER,
          weekFilter: newDate
      });
    };
}

export function clean(obj) {
    if(!isObject(obj)){
        return obj
    }

    for (let propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
          delete obj[propName];
      }
    }
    return obj
}

export function refSave(firebase, ref, info) {
    let user = firebase.auth().currentUser;
    if (isObject(info)) {

        delete info['uid']
        delete info['createdAt']
        delete info['updatedAt']
        delete info['createdId']

        info["createdAt"] = firebase.database.ServerValue.TIMESTAMP;
        info["updatedAt"] = firebase.database.ServerValue.TIMESTAMP;


        if (!!user) {
          info["createdId"] = user.uid;
      }
    }


    return ref.set(clean(info));
}

export function refUpdate(firebase, ref, info) {
    if (isObject(info)) {

        delete info['uid']
        delete info['createdAt']
        delete info['updatedAt']
        delete info['createdId']

        info['updatedAt'] = firebase.database.ServerValue.TIMESTAMP;
    }

    return ref.update(clean(info))
}

function saveProfile(firebase, email, firstName, lastName, user, phoneNumber) {

    return refSave(firebase, firebase.database().ref(`/users/${user.uid}`), clean({
        first_name: firstName,
        last_name: lastName,
        phoneNumber: phoneNumber,
        email: email.toLowerCase()
    }));
}

function addInviteUsers(projectId, emails, plan, existingUsers){

    // split comma separated emails into an array of emails
    const _emails = emails.split(',').map(email => email.trim())
    // Number of users including the inviter
    const projectedUsers = existingUsers + _emails.length;

    // if plan is concrete and total amount of users is more than 2
    /*if(plan === "Concrete" && projectedUsers > 2){
        return (dispatch, getState) => {
            dispatch(alertActions.error('Max users for project reached'));
        }
    }*/

    // if plan is brick and total amount of users is more than 10
    /*if(plan === "Brick" && projectedUsers > 10){
        return (dispatch, getState) => {
            dispatch(alertActions.error('Max users for project reached'));
        }
    }*/
    return (dispatch, getState) => {
        return Promise.all(_emails.map(email => dispatch(addInviteUser(projectId, email))))
    }
}

// wrapper for individual invite user function to check for plan
function addInviteUserWithPlan(projectId, email, plan, existingUsers){
    const projectedUsers = existingUsers + 1;

    /*if(plan === "Concrete" && projectedUsers > 2){
        return (dispatch, getState) => {
            dispatch(alertActions.error('Max users for project reached'));
        }
    }

    if(plan === "Brick" && projectedUsers > 10){
        return (dispatch, getState) => {
            dispatch(alertActions.error('Max users for project reached'));
        }
    }*/
    
    return(dispatch, getState) => {
        return dispatch(addInviteUser(projectId, email))
    }

}

function addInviteUser(projectId, email) {
    const firebase = getFirebase();

    const _email = email.toLowerCase();
    return (dispatch, getState) => {
        dispatch(request(email));
        return firebase
      .database()
      .ref('/users')
      .orderByChild('email')
      .equalTo(_email).limitToLast(1).once('value').then( foundUser => {
          if(!!foundUser.val()){
              return firebase.database().ref(`/projects/${projectId}`).once('value', projectSnap => {
                  const userId = Object.keys(foundUser.val())[0];
                  
                  
                  const projectsRolesPromise = refSave(firebase, firebase.database().ref(`/projects/${projectId}/roles/${userId}`), {
                    type: 'Collaborator'
                  });

                  const projectsUsersPromise = refSave(firebase, firebase.database().ref(`/projects/${projectId}/users/${userId}`), true);
                  const userProjectPromise = refSave(firebase, firebase.database().ref(`/users/${userId}/projects/${projectId}`), { name: projectSnap.val().name })

                  return Promise.all([projectsUsersPromise, userProjectPromise, projectsRolesPromise])
              })
          }  {
              const userInvitesRef = firebase.database().ref('/user_invites');
              const newUserInvitesKey = userInvitesRef.push().key
              return refSave(firebase, firebase.database().ref(`/user_invites/${newUserInvitesKey}`), {
                  project_uid: projectId,
                  user_email: _email
              });
          }
      }).then(() => {
          dispatch(alertActions.success("Invite successful"));
          dispatch(success(email))
          dispatch({ type: homeConstants.INVITEDIALOG_CLOSE })
      }).catch(e => {
      dispatch(alertActions.error('Invite Error'));
      dispatch(failure(e.toString()))
      bugsnagClient.notify(e)
  })


        function request(email) {
          return {
            type: entityConstants.INVITE_REQUEST,
            meta: {
              
          }
        };
      }

        function success(email) {
          return {
            type: entityConstants.INVITE_SUCCESS,
            meta: {
              mixpanel: {
                eventName: "INVITE-SUCCEEDED-EVENT",
                props: {
                  email,
                  source: "website"
              }
            },
               
          }
        };
      }

        function failure(error) {
          return {
            type: entityConstants.INVITE_FAILED,
            error,
            meta: {
              mixpanel: {
                eventName: "INVITE-SUCCEEDED-ERROR-EVENT",
                props: {
                  error: humanize(error),
                  source: "website"
              }
            },
               
          }
        };
      }
    };
}

function endLookAhead(projectId, tasks, lookAheadId) {
    const firebase = getFirebase();
    return (dispatch, getState) => {
        return Promise.all([
          refUpdate(
        firebase,
        firebase.database().ref(`/projects/${projectId}/lookaheads/${lookAheadId}`),
            {
                status: ProjectLookAheadStatus.CLOSED
            }
      ),
          refUpdate(firebase, firebase.database().ref(`/lookaheads/${lookAheadId}`), {
            snapshotEnd: tasks
        })
      ]).then(() => dispatch(alertActions.success('LookAhead Ended')))
    }
}

function createId(route) {
    const firebase = getFirebase();

    const Ref = firebase.database().ref(route);

    const key = Ref.push().key;
  
    return key
}

function createLookAhead(projectId, tasks) {
    const firebase = getFirebase();

    return (dispatch, getState) => {
        const lookAheadRef = firebase.database().ref(`/lookaheads`);

        const lookAheadKey = lookAheadRef.push().key;
        return Promise.all([
          refSave(
        firebase,
        firebase.database().ref(`/projects/${projectId}/lookaheads/${lookAheadKey}`),
            {
                status: ProjectLookAheadStatus.OPEN
            }
      ),
          refSave(firebase, firebase.database().ref(`/lookaheads/${lookAheadKey}`), {
            snapshotStart: tasks
        })
      ]).then(() => dispatch(alertActions.success('LookAhead Started'))).then(() => console.log('key: ', lookAheadKey))
    }
}

function closeProjectDialog() {
    return (dispatch, getState) => {
        dispatch({
          type: entityConstants.CLOSE_PROJECT_DIALOG,
          meta : {
             
        }
      })
    }
}


function createProject(projectId, name, address, longitude, latitude) {
    const firebase = getFirebase();

    return async (dispatch, getState) => {
      const offDays = getOffDays(getState())
      const offDaysClean = !!offDays ? Array.from<number>(offDays)  :[]

      const user = firebase.auth().currentUser;
      const projectRef = firebase
      .database()
      .ref()
      .child("projects");

        var newProjectKey = projectId

        if(!projectId){
          newProjectKey = projectRef.push().key;
      }

        const project = {
          name,
          address,
          longitude,
          latitude,
      };

        if(!projectId) {
          project["users"] = {
            [user.uid]: true
        }
          project["roles"] = {
            [user.uid]: {
              type: "Admin"
          }
        };

          project['schedules'] = {master_schedule_id: {
            name: 'Master Schedule',
            users:{
              [user.uid]: true
          },
            owners: {
              [user.uid]: true
          },
            createdId: [user.uid],
            createdAt: firebase.database.ServerValue.TIMESTAMP,
            updatedAt: firebase.database.ServerValue.TIMESTAMP
        }}
      }
        await firebase.database().ref(`/dailyReport/projects/${newProjectKey}/settings/`).update({
          reportDays: offDaysClean
        })

        dispatch(request(project));
        return Promise.all([
          refUpdate(
        firebase,
        firebase.database().ref(`/projects/${newProjectKey}`),
        project
      ),
          refUpdate(
        firebase,
        firebase.database().ref(`/users/${user.uid}/projects/${newProjectKey}`),
        project
      )
      ])
      .then(() => {
          dispatch(projectActions.selectProject(newProjectKey))
          dispatch(success(project, newProjectKey));
      })
      .catch(e => {
          dispatch(failure(e.toString()));
          bugsnagClient.notify(e)
      });
    };

    function request(project) {
        return {
          type: entityConstants.ADD_PROJECT_REQUEST,
          project,
          meta: {
            mixpanel: {
              eventName: "CREATE-PROJECT-REQUEST-EVENT",
              props: {
                name: project.name,
                address: project.project_address,
                city: project.project_city,
                zipcode: project.project_zipcode,
                source: "website"
            }
          },
             
        }
      };
    }

    function success(project, projectId) {
        return {
          type: entityConstants.ADD_PROJECT_SUCCESS,
          project,
          selectedProjectId: projectId,
          meta: {
            mixpanel: {
              eventName: "CREATE-PROJECT-SUCCESS-EVENT",
              props: {
                name: project.name,
                address: project.project_address,
                city: project.project_city,
                zipcode: project.project_zipcode,
                source: "website"
            }
          },
             
        }
      };
    }

    function failure(error) {
        return {
          type: entityConstants.ADD_PROJECT_FAILURE,
          error,
          meta: {
            mixpanel: {
              eventName: "CREATE-PROJECT-ERROR-EVENT",
              props: {
                error: humanize(error),
                source: "website"
            }
          },
             
        }
      };
    }
}

function saveUploadTasksTask(projectId, fileId, fileName, file) {
    const firebase = getFirebase();

    return (dispatch, getState) => {
        return firebase
      .uploadFiles(`/uploadedFiles/${projectId}/files/${fileId}`, file)
      .then(uploadTask => {
          return refUpdate(
          firebase,
          firebase
            .database()
            .ref(`/uploadedFiles/${projectId}/files/${fileId}`),
              {
                  name: fileName,
                  status: "pending"
              }
        ).then(() => {
            dispatch({
                type: homeConstants.UPLOAD_TASKDIALOG_CLOSED,
                meta : {
                   
              }
            });
        });
      });
    };
}


function saveFormData(firebase, projectId, entityId, formData, scheduleAdds, scheduleDels, orginalSchedule) {
    return async (dispatch, getState) => {
        if(formData.code == null) {
          formData['code'] = ''
      }

        const entityRoute = `projects/${projectId}/tasks/${entityId}`
        refUpdate(
      firebase,
      firebase.database().ref(entityRoute),
      formData
    )

        if(scheduleAdds.length > 0 || scheduleDels.length > 0){
          scheduleAdds.forEach(async scheduleId => {
            const route = `projects/${projectId}/schedules/${scheduleId}/tasks/${entityId}`

            refSave(
          firebase,
          firebase.database().ref(route),
          true
        )
        })

          scheduleDels.forEach(async scheduleId => {
            const route = `projects/${projectId}/schedules/${scheduleId}/tasks/${entityId}`
            firebase.database().ref(route).remove()
        })
      } else {
          orginalSchedule.forEach(async scheduleId => {
            const route = `projects/${projectId}/schedules/${scheduleId}/tasks/${entityId}`

            refSave(
          firebase,
          firebase.database().ref(route),
          true
        )
        })
      }


        dispatch({
          type: homeConstants.EDITBOARD_CLOSE,
          editBoardInfo: null,
          meta: {
            mixpanel: {
              eventName: "UPSERT-ENTITY-EVENT",
              props: {
                entityRoute,
                formData,
                source: "website"
            }
          },
             
        }
      });

        dispatch(alertActions.success('Task Saved!'))
    };
}



const colors = [
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#009688',
  '#4CAF50',
  '#FF9800',
  '#FFEB3B',
  '#FF5722',
  '#795548',
  '#9E9E9E',
  '#607D8B'
]

const randomColor = () => {
  return _.sample(colors)
}


function uploadTasks(tags: TagToBeUploaded[]) {
  const firebase = getFirebase();

  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        try {
          const projectId = getProjectId(getState())
          const lookaheadId = getSelectedLookaheadId(getState())
          const offDays = getLookaheadOffDays(getState())
          const maxRow = getRowGroupMaxEnds(getState())
          
          const entityRoute = `/projects/${projectId}/lookaheads/${lookaheadId}/tags/`;

          const ref = firebase.database().ref(entityRoute);
          const user = firebase.auth().currentUser;
          const userId = user?.uid

          const updates:Record<string, LookaheadTag | RowGroup> = {};


          // update trades

          const newTradeMap:Record<string, string> = {}
          dispatch(homeActions.openCircularProgressLoading());

          const groupedByTradeId = _.groupBy(tags, 'tradeId')
          Object.keys(groupedByTradeId).forEach(async tradeId => {
            if(tradeId.includes(NEW_TRADE)) {
              if(!newTradeMap[tradeId]){
                const newTradeId = ref.push().key as string
                newTradeMap[tradeId] = newTradeId
                const tradeName = tradeId.replace(`${NEW_TRADE}/`,'');
                if(!!userId) {
                  const trade:Trade = {
                    name: tradeName,
                    color: randomColor(),
                    users: {
                      [userId]: true
                    }
                  }

                  updates[`/projects/${projectId}/lookaheads/${lookaheadId}/trades/${newTradeId}`] = trade
                }
              } 
            }
          })
          


          let indexId = maxRow + 1

          const groups: Partial<RowGroup>[] = []

          let currentGroupName: string | null = null
          let currentGroup: Partial<RowGroup> | null = null

          tags.sort((a, b) => {
            if(!!a.groupName && !b.groupName) {
              return -1
            }

            if(!a.groupName && !!b.groupName) {
              return 1
            }
            if(a.groupName != b.groupName){ 

              return a.groupName?.localeCompare(b.groupName)
            }
            const aDate = convertDate(a.startDate)
            const bDate = convertDate(b.startDate)
            if(aDate?.valueOf() === bDate?.valueOf()) {
              if(a.tradeId < b.tradeId) {
                return -1
              }

              if(a.tradeId > b.tradeId) {
                return 1
              }

              return 0
            }
            return aDate?.valueOf() - bDate?.valueOf()
          }).forEach(tag => {
            const startDate = convertDate(tag.startDate)
            const endDate = convertDate(tag.endDate)

            if(!endDate || !startDate) {
              
            } else {
              const daysBetween = endDate.diff(startDate, 'days')
              const daysBridge = daysBetween > 0 ? daysBetween : 0
              let additonOffset = 0

              Array(daysBridge+1).fill(1).map((item, index) => {
                if(tag.groupName != currentGroupName) {
                  currentGroupName = tag.groupName

                  const groupName = tag.groupName
                  if(!!groupName) {
                    if(!currentGroup) {
                      currentGroup = {
                        start: indexId,
                        name:  groupName,
                      }
                    } else {
                      currentGroup['end'] = indexId - 1
                      groups.push(currentGroup)
                      currentGroup = {
                        start: indexId,
                        name:  groupName
                      }
                    }
                    
                  }
                } else {
                  if(!!currentGroup) {
                    currentGroup['end'] = indexId - 1
                  }
                }


                const tempStartDate = convertDate(tag.startDate)
                
                
                if(!!tempStartDate) {
                  const tagDate =  tempStartDate.add(index + additonOffset, 'days')
                  if(!offDays.has(tagDate.day())){

                    const newTagId = ref.push().key

                    let tradeId = tag.tradeId // can be NEW_TRADE/BB

                    if(!!newTradeMap[tradeId] /*can be NEW_TRADE/BB*/) {
                      tradeId = newTradeMap[tradeId] // cant be can be NEW_TRADE/BB*
                    }


                    if(indexId >= 0 ){
                      updates[`${entityRoute}${newTagId}`] = {
                        name: tag.name,
                        locationId: !!tag.locationId ? tag.locationId : 'Floor 1',
                        crewSize: !!tag.crewSize ? parseInt(tag.crewSize,0) : 0,
                        status: LookaheadTagStatus.Todo,
                        indexId: indexId,
                        tagDate: tagDate.format('l'),
                        tradeId: tradeId
                      };
                    } else {
                      console.error('Import error', indexId)
                    }
                  }
                }
              })
            }

            indexId += 1
          })
        
        if(!!currentGroup) {
          groups.push(currentGroup)
        }
        

        

        groups.forEach(group => {
          const ref = firebase.database().ref();
        
          const groupId:string = ref.push().key as string

            updates[`/projects/${projectId}/lookaheads/${lookaheadId}/row_groups/${groupId}/`] = {
              start: group.start,
              end: group.end,
              name: group.name
          }
        })
        
        return firebase.database().ref().update(updates).then(() => {
          dispatch(homeActions.closeCircularProgressLoading());

        }).catch(e => {
          dispatch(homeActions.closeCircularProgressLoading());
          bugsnagClient.notify(e)

        })
        
      } catch(e) {
        console.error('Error Uploading', e)
        dispatch(alertActions.error('Error Uploading'))

      }
    }
}



function removeTaskByRoute(projectId, taskId) {
    const firebase = getFirebase();

    return (dispatch, getState) => {
        const entityRoute = `projects/${projectId}/tasks/${taskId}`
        return firebase
      .database()
      .ref(entityRoute)
      .remove()
      .then(() => {
          dispatch({
              type: entityConstants.REQUEST_UPDATE_PENDING,
              meta: {
                mixpanel: {
                  eventName: "REMOVE-ENTITY-EVENT",
                  props: {
                    entityRoute,
                    source: "website"
                }
              },
                 
            }
          });
          dispatch(alertActions.success("Task Deleted"));
      });
    };
}

function requestUpdate(taskIds) {
    return (dispatch, getState) => {
        dispatch({
          type: entityConstants.REQUEST_UPDATE,
          updateRequest: {
            taskIds
        },
          meta : {
             
        }
      });
    };
}

function closeUpdateRequestDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: entityConstants.REQUEST_DIALOG_CLOSE,
            meta : {
                 
            }
        });
    };
}

function sendUpdateRequest(projectId, emailTo, emailFrom, fromName, taskIds) {
    const firebase = getFirebase();
    const updateRequestRef = firebase.database().ref("/updateRequest");

    const updateRequestKey = updateRequestRef.push().key;

    const entityRoute = `/updateRequest/${updateRequestKey}`;
    const reportUpdateUrl = `http://${
    window.location.host
  }/updateRequest/${updateRequestKey}/portal`;

    return (dispatch, getState) => {
        return refSave(firebase, firebase.database().ref(entityRoute), {
          projectId,
          emailTo,
          emailFrom,
          taskIds,
          fromName,
          reportUpdateUrl
      }).then(() => {
        dispatch({
            type: entityConstants.REQUEST_UPDATE_PENDING,
            meta: {
              mixpanel: {
                eventName: "REQUEST-UPDATE-PENDING-EVENT",
                props: {
                  updateRequestId: updateRequestKey,
                  projectId,
                  emailTo,
                  emailFrom,
                  taskIds,
                  source: "website"
              }
            },
               
          }
        });
        dispatch(alertActions.success("Request Sent"));
    });
    };
}

function saveUpdateRequestProgress(updateProgressId) {
    const firebase = getFirebase();

    const entityRoute = `/updateRequest/${updateProgressId}`;

    return (dispatch, getState) => {
        return refUpdate(firebase, firebase.database().ref(entityRoute), {
          status: "done"
      }).then(() => {
        dispatch({
            type: entityConstants.REQUEST_UPDATE_DONE,
            meta: {
              mixpanel: {
                eventName: "REQUEST-UPDATE-PROGESS-FINISHED",
                props: {
                  updateProgressId,
                  source: "website"
              },
                 
            }
          }
        });
        dispatch(alertActions.success("Request Saved"));
    });
    };
}

function uploadedSchedule(projectId, importOption, scheduleId, file) {
    const firebase = getFirebase();

    const entityRoute = `/projects/${projectId}/schedule_imports/`;
    return firebase
    .uploadFile(`${entityRoute}`, file, `${entityRoute}`)
    .then(jobResult => {
        const newKey = jobResult.key;
        const downloadUrl = jobResult.downloadURL;
        return refUpdate(
        firebase,
        firebase.database().ref(`${entityRoute}${newKey}`),
            {
                import_status: "processing",
                downloadUrl,
                scheduleId,
                importOption
            }
      ).then(() => {
          return jobResult;
      });
    });
}

export const getDbFromType = (type: ColumnType) => {
  if(type === ColumnType.PhasePlan || type == 'PhasePlanTagType') {
    return 'phases'
  }

  if(type === ColumnType.Lookahead || type == 'LookaheadTagType') {
    return 'lookaheads'
  }

  throw new Error("wtf bro")
}

export const getLeastPlannerTags = (state: any, type: ColumnType) => {
  if(type === ColumnType.PhasePlan || type == 'PhasePlanTagType') {
    return getPhaseTags(state)
  }
  if(type === ColumnType.Lookahead || type == 'LookaheadTagType') {
    return {...getLookaheadTags(state), ...getLookaheadMilestoneTags(state)}
  }

  throw new Error(`Invalid Tag ${type}`)

}

export const getLeastPlannerId = (state:any, type: ColumnType) => {
  if(type === ColumnType.PhasePlan || type == 'PhasePlanTagType') {
    return getSelectedPhasePlanId(state)
  }
  if(type === ColumnType.Lookahead || type == 'LookaheadTagType') {
    return getSelectedLookaheadId(state)
  }

  throw new Error(`Invalid Tag ${type}`)
}

function deleteTag(tagIds:Record<string, SelectedTag>, type: ColumnType) {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        try {
            const firebase = getFirebase()           
            const projectId = getProjectId(getState())
            const phasePlanId = getLeastPlannerId(getState(), type)
            const dbType = getDbFromType(type)
            const milestoneKeys = getMilestoneKeys(getState())
            
            const entityRoutesUpdates = Object.keys(tagIds).reduce((obj:Record<string, any>, tagId:string) => {
              const selectedTag = tagIds[tagId]
              const tagType = getDbFromTagType(selectedTag.tagCardType, milestoneKeys.has(tagId))
              obj[`/projects/${projectId}/${dbType}/${phasePlanId}/${tagType}/${tagId}`] = null

              return obj
            },{} as Record<string, any>)

            await firebase.database().ref().update(entityRoutesUpdates)
            dispatch(alertActions.success('Tag Deleted'))
        } catch(e) {
          console.error('delete error', e)

          dispatch(alertActions.error('Error Deleting Tag'))
        }
    }
}

function deleteTrade(tradeIds:string []) {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
      try {
          const firebase = getFirebase()           
          const projectId = getProjectId(getState())
          const phasePlanId = getSelectedPhasePlanId(getState())
          const dbType = getDbFromType(ColumnType.PhasePlan)
          
          const entityRoutesUpdates = tradeIds.reduce((obj, tagId) => {
            obj[`/projects/${projectId}/${dbType}/${phasePlanId}/trades/${tagId}`] = null

            return obj
          },{} as Record<string, any>)

          await firebase.database().ref().update(entityRoutesUpdates)

          
          dispatch(alertActions.success('Trade Deleted'))
      } catch(e) {
        console.error('delete error', e)

        dispatch(alertActions.error('Error Deleting Trade'))
      }
  }
}

function duplicateTrade(tradeIds: string[]) {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
    const firebase = getFirebase()  
    const state = getState()         
    const projectId = getProjectId(getState())
    const trades = getTrades(state)
    const phasePlanId = getSelectedPhasePlanId(state)
    
    if(!tradeIds || tradeIds.length <= 0) {
        dispatch(alertActions.error('Error Duplicating Trade'))
        return
    }
    
    try {
      const dbType = getDbFromType(ColumnType.PhasePlan)

      const entityRoute = `/projects/${projectId}/${dbType}/${phasePlanId}/trades`

      const entityRoutesUpdates = tradeIds.reduce((obj, tradeId) => {
        const trade:Trade = trades[tradeId]
        
        const tradeRef = firebase.database().ref(entityRoute);
        const newTradeKey = tradeRef.push().key

        delete trade['uid']
        
        obj[`${entityRoute}/${newTradeKey}`] = trade

        return obj
      },{} as Record<string, any>)

      await firebase.database().ref().update(entityRoutesUpdates)

      dispatch(alertActions.success('Trade Duplicated'))
    }catch (e) {
      console.error('dup error', e)
      dispatch(alertActions.error('Error With Duplicate'))
      bugsnagClient.notify(e)

    }
}
}

function duplicateTag(tagIds: Record<string, SelectedTag>, type: ColumnType) {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const firebase = getFirebase()           
        const projectId = getProjectId(getState())
        const tags = getLeastPlannerTags(getState(), type)
        const phasePlanId = getLeastPlannerId(getState(), type)

        if(!tagIds || Object.keys(tagIds).length <= 0) {
            dispatch(alertActions.error('Error Duplicating Tag'))
            return
        }

        try {
          const dbType = getDbFromType(type)

          const entityRoutesUpdates = Object.keys(tagIds).reduce((obj, tagId:string) => {
            const tag:Tag = {...tags[tagId]}
            tag.indexId = ( !!tag.indexId ? tag.indexId + 1 : 1)

            const selectedTag = tagIds[tagId]
            const tagType = getDbFromTagType(!!selectedTag.tagType ? selectedTag.tagType : selectedTag.tagCardType )
            
            const entityRoute = `/projects/${projectId}/${dbType}/${phasePlanId}/${tagType}`
            const tagRef = firebase.database().ref(entityRoute);
            const newTagKey = tagRef.push().key

            delete tag['uid']
            delete tag['dayOffset']
            delete tag['createdAt']
            delete tag['tagCardType']
            delete tag['tagType']


            if(!_.isEqual(tag, tags[tagId])) {
              obj[`${entityRoute}/${newTagKey}`] = tag
            } else {
              throw new Error('Invalid index update')
            }


            return obj
          },{} as Record<string, any>)

          await firebase.database().ref().update(entityRoutesUpdates)

          dispatch(alertActions.success('Tag Duplicated'))
        }catch (e) {
          console.error('dup error', e)
          dispatch(alertActions.error('Error With Duplicate'))
          bugsnagClient.notify(e)

        }
    }
} 

function ripTag(tagId:string, tag:PhaseTag, ripAmount: number) {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const projectId = getProjectId(getState())
        const firebase = getFirebase()         
        const phasePlanId = getSelectedPhasePlanId(getState())
  

        const leftAmount = tag.duration - ripAmount
        const rightAmount = ripAmount

        const updates:Record<string, object> = {}

        const entityRoute = `/projects/${projectId}/phases/${phasePlanId}/tags/`;

        const ref = firebase.database().ref(entityRoute);
        const newTagId = ref.push().key;

        updates[`${entityRoute}${tagId}`] = {
            duration: leftAmount
        }
        const newTag = { ... tag }
        newTag.duration = rightAmount
        updates[`${entityRoute}${newTagId}`] = newTag

        delete newTag['uid']
        delete newTag['tagCardType']

        if(!!tag.column) {
            newTag.column = tag.column + 1
        }
        try{

            await refUpdate(
              firebase,
              firebase.database().ref(`${entityRoute}${tagId}`),
                {
                    duration: leftAmount
                }
            )
            
            await refSave(firebase,
              firebase.database().ref(`${entityRoute}${newTagId}`),
              newTag
            )
            
        } catch(e) {
            dispatch(alertActions.error('Error Ripping Tag'))
        }


        dispatch(alertActions.success('Tag Ripped'))
        
    }
}



// WEBPACK FOOTER //
// ./src/actions/entity.actions.ts